import React, { useEffect, useState, useRef, Fragment } from "react";
import * as Icon from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Dialog, Transition } from '@headlessui/react'
import {
  fetchHubspotMappingData,
  getConnectHubspot,
  getHubspotToken,
  getSyncFields,
  hubspotAuth,
  unlinkHubspotApi,
  fetchSyncPopupListing,
  hubspotDeleteData,
  submitPopupSyncData,
  hubspotSyncData,
} from "../../redux/actions/settingActions";
import Unlink from "../../assets/unlink.svg"
import { useNavigate } from "react-router";
import hubspot from "../../assets/1200px-HubSpot_Logo.svg.png";
import Toast from "../assetLibComponents/shared/Toast";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

const SettingHubspot = (props) => {
  const dispatch = useDispatch();
  const hubspotStatus = useSelector((state) => state.setting.hubspotStatus);
  let navigate = useNavigate();
  const cancelButtonRef = useRef(null)
  const [open, setOpen] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false);
  const [syncListData, setSyncListData] = useState(null);
  const fData = useSelector((state) => state.setting.fieldsData?.hubspot_fields);
  const syncPopupData = useSelector((state) => state.setting.fetchSyncPopupList);
  const hubspotDeleteCheck = useSelector(
    (state) => state.setting.hubspotDeleteData
  );

  useEffect(() => {
    // Get the current URL
    const currentURL = window.location.href;
    // Create a URL object to parse the URL
    const url = new URL(currentURL);
    // Get the "code" query parameter value
    const eCode = url.searchParams.get("code");
    if (eCode) {
      // Do something with the extracted "code" value
      console.log("Extracted code:", eCode);
      dispatch(getHubspotToken(props.authToken, eCode));

      // You can now use the "code" in your React component's state or perform any desired actions.
    } else {
      console.log("No code parameter found in the URL");
    }
    // Cleanup: Set isMounted to false when the component unmounts
    dispatch(getConnectHubspot(props.authToken));
    dispatch(fetchHubspotMappingData(props.authToken));
    dispatch(hubspotDeleteData(props.authToken));
    dispatch(getSyncFields(props.authToken));
  }, []);
  // const hubspotUrl = useSelector((state) => state.setting.fetchCalendlyUrl);

  const handleConnectHubspot = () => {
    dispatch(hubspotAuth(props.authToken));
  };
  const handleSync = () => {
    navigate("/Setting/syncFields");
  };
  // const handleSyncHubspot = () => {
  //   dispatch(hubspotSyncData(props.authToken, onSuccess));
  // };
  
  const onSuccess = (name) => {
    Toast(`${name} lead sync successfully.`,"S")
  }
  
  const handleUnlinkHubspot = async () => {
    await dispatch(unlinkHubspotApi(props.authToken));
    await dispatch(getConnectHubspot(props.authToken));
    deleteHandleClose();
  }
  
  const deleteHandleClose = () => {
    setDeleteModal(false);
  };
  
  return (
    <>
      {hubspotStatus === "Connected" ? (
        <div>
          <div className="flex max-sm:flex-col justify-between">
            <img
              className="h-16 w-auto max-sm:w-56 my-auto"
              src={hubspot}
              alt="Your Company"
            />
            {/* <div className="flex mr-4">
              <Icon.CheckCircle className="text-lg my-auto text-green-400 mr-2" />
              <div className="text-green-400 text-lg my-auto">Connected</div>
            </div> */}
          </div>
          <div className="my-4 text-sm sm:w-[70%] xl:w-[60%]">
            Using HubSpot? Great! Toggling the options below will allow you to
            send conversation events into HubSpot as well as automatically
            identify visitors using the HubSpot cookie.
          </div>
          
          <ul>
          <li className="flex flex-col gap-x-6 cursor-pointer" onClick={handleSync}>
            <hr className="border-[1] my-4 border-gray-600"/>
            <div className="text-base font-[500]">Select HubSpot Fields</div>
            <div className="text-sm text-gray-500">Choose HubSpot fields to show inside Zoi</div>
            <hr className="border-[1] my-4 border-gray-600"/>
          </li>
          {fData?.length > 0 && <li className="flex flex-col gap-x-6 cursor-pointer" onClick={()=>{navigate("/Setting/hubspotMapping")}}>
            <div className="text-base font-[500]">Mapped Hubspot Attributes</div>
            <div className="text-sm text-gray-500">Map which fields you want to sync between Zoi and Hubspot</div>
            <hr className="border-[1] my-4 border-gray-600"/>
            </li>}
          {fData?.length > 0 && <li className="flex flex-col gap-x-6 cursor-pointer" onClick={()=>{navigate("/Setting/syncedHubspot")}}>
            <div className="text-base font-[500]">Synced Hubspot Data</div>
            <div className="text-sm text-gray-500">Choose which data is sent between Hubspot and Zoi.</div>
            <hr className="border-[1] my-4 border-gray-600"/>
          </li>}
          </ul>
          <div className="flex max-sm:block mt-8">
            {hubspotDeleteCheck?.hubspot_map_fields?.length > 0 && <div
              className="flex justify-center h-[28px] cursor-pointer bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] w-[200px] text-white rounded-md text-sm p-1"
              // onClick={handleSyncHubspot}
              onClick={async () => {
                await dispatch(fetchSyncPopupListing(props.authToken));
                await setOpen(true);
              }}
            >
              <span className="flex">
                <Icon.Link45deg className="text-[20px] mr-2" />
                Sync HubSpot
              </span>
            </div>}
            {hubspotDeleteCheck?.hubspot_map_fields?.length > 0 && <div
              className="flex justify-center h-[28px] cursor-pointer bg-[#c0503f] hover:bg-[#c6796d] w-[200px] text-white rounded-md text-sm ml-4 max-sm:ml-0 max-sm:mt-8 p-1"
              // onClick={handleUnlinkHubspot}
              onClick={() => { setDeleteModal(true) }}
            >
              <span className="flex">
                <img src={Unlink} alt="Unlink" className='text-[20px] w-5 h-[18px] mr-2'/>
                Disconnect HubSpot
              </span>
            </div>}
          </div>
        </div>
      ) : (
        <>
        <div className="flex max-sm:flex-col justify-between">
            <img
              className="h-16 w-auto my-auto"
              src={hubspot}
              alt="Your Company"
            />
            {/* <div className="flex mr-4">
              <Icon.CheckCircle className="text-lg my-auto text-green-400 mr-2" />
              <div className="text-green-400 text-lg my-auto">Connected</div>
            </div> */}
          </div>
          <div className="my-4 text-sm sm:w-[70%] xl:w-[60%]">
            Using HubSpot? Great! Toggling the options below will allow you to
            send conversation events into HubSpot as well as automatically
            identify visitors using the HubSpot cookie.
          </div>
        <div
          className="flex justify-center h-[28px] cursor-pointer bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] w-[200px] text-white rounded-md text-sm p-1 mt-8"
          onClick={handleConnectHubspot}
        >
          <span className="flex">
            <Icon.Link45deg className="text-[20px] mr-2" />
            Connect HubSpot
          </span>
        </div>
        </>
      )}
      <Transition.Root show={deleteModal} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={deleteHandleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-left sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <div className="rounded-md bg-yellow-50 p-4 w-1/2 max-sm:w-full">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
                      </div>
                      <div className="ml-3">
                        <h3 className="text-base font-medium text-yellow-800">Warning!</h3>
                        <div className="mt-2 text-sm text-yellow-700">
                          <p>
                            Disconnecting your HubSpot account will stop the syncing and updating of any lead data between HubSpot and Zoi. If you have used any fields imported from HubSpot in the creation of progressive profiling questions, then they will be disassociated and new fields will have to be assigned to them to continue functioning.
                          </p>
                        </div>
                        <div className="mt-8">
                          <div className="-mx-2 -my-1.5 flex">
                            <button
                              type="button"
                              className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-sm font-medium text-green-700 ring-1 ring-inset ring-green-600/20"
                              onClick={handleUnlinkHubspot}
                            >
                              I Understand
                            </button>
                            <button
                              type="button"
                              className="ml-3 inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-sm font-medium text-gray-800 ring-1 ring-inset ring-yellow-600/20"
                              onClick={deleteHandleClose}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

      
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg sm:p-6">
                    <div>
                      <p className="text-base font-semibold border-b border-gray-200 pb-4">HubSpot Sync List</p>
                      <div className="p-4 pl-0 flex text-xs max-sm:m-auto items-center w-full max-sm:w-auto justify-between max-sm:px-1 px-2 max-sm:py-2 py-5 sm:p-1.5 mt-2 bg-[#F3F4F6] border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)]">
                        <span className="w-[15%] font-medium">S No.</span>
                        <div className="w-[85%] flex justify-between">
                          <span className="w-[33.3%] capitalize font-semibold">List Name</span>
                          <span className="w-[33.3%] font-semibold">
                            Type
                          </span>
                          <span className="w-[33.3%] text-right font-semibold pr-2">Created At</span>
                        </div>
                      </div>
                      <div className="h-[40vh] overflow-y-auto">
                      {syncPopupData?.length > 0 ? <>
                      {syncPopupData?.map((item, index) => {
                        return (
                          <div className={"py-2 pl-0 flex rounded-md hover:bg-[var(--brand-primary)] my-1 hover:text-white cursor-pointer "+ (syncListData?.listId === item.listId ? "bg-[var(--brand-primary)] text-white":"bg-white text-black")} onClick={()=>{setSyncListData(item)}}>
                            <span className="w-[15%] px-4 font-medium">{index + 1}.</span>
                            <div className="w-[85%] flex justify-between">
                              <span title={item.name} className="w-[33.3%] pr-8 capitalize whitespace-nowrap overflow-hidden text-ellipsis">{item.name}</span>
                              <span className="w-[33.3%]">
                                <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                  {item.processingType}
                                </span>
                              </span>
                              <span className="w-[33.3%] text-right pr-2">{item.createdAt.slice(0,10)}</span>
                            </div>
                          </div>
                        );
                      })}
                      </>:
                      <>
                        <div className="text-[rgba(33,33,33,0.3)] text-[17px] h-full pt-24 font-[bolder] text-center font-add">
                          <span className="flex justify-center items-center text-[40px]">
                            <Icon.Inbox />
                          </span>
                          No Data
                        </div>
                      </>}
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                        onClick={async () => {
                          if (syncListData && Object.keys(syncListData).length > 0) {
                            setOpen(false)
                            await dispatch(submitPopupSyncData(props.authToken, syncListData?.listId, syncListData?.name, onSuccess));
                            setSyncListData(null)
                          } else {
                            Toast("Please select a list","E");
                          }   
                        }}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                        onClick={() => {
                          setSyncListData(null)
                          setOpen(false)
                        }}
                        ref={cancelButtonRef}
                      >
                        Close
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
    </>
  );
};

export default SettingHubspot;
